/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../notes/notes.ts"/>

namespace DealerwareWebServices {
    "use strict";

    export interface IDealerwareCustomerFactory {
        loadCustomer(locationId: number, id: number) : ng.IPromise<{}>;
        getInstance() : IDealerwareCustomer;
    }

    export interface IDealerwareCustomer extends IDealerwareHasNotes {
        locationId: number;
        customerId: number;
        accountSettings: any;
        driversLicense: any;
        creditCard: any;
        creditCards: any;
        contracts: any;
        fullName: string;
        paymentProcessor: any;

        clear() : void;
        clearAccountSettings() : void;
        loadAccountSettings(locationId?: number, customerId?: number) : ng.IPromise<{}>;
        loadDriversLicense() : ng.IPromise<{}>;
        loadCreditCards() : ng.IPromise<{}>;
        loadPaymentProcessor() : ng.IPromise<{}>;
        loadNotes() : ng.IPromise<{}>;
        loadContracts() : ng.IPromise<{}>;
        deleteInsuranceImage(locationId?: number, customerId?: number) : ng.IPromise<{}>;
        saveInsurance() : ng.IPromise<{}>;
        searchDisplay() : string;
    }
}
